import '@chewy/kib-product-styles/dist/styles/kib-product-rating.css';

import { KibAwardIcon } from '@chewy/kib-icons-react';
import { KibProductRating } from '@chewy/kib-product-react';
import cx from 'classnames';

import styles from './styles.module.scss';

export const Testimonial = ({
  title,
  text,
  author,
  className,
}: {
  title: string;
  text: string;
  author: string;
  className?: string;
}) => {
  return (
    <div className={cx(styles.root, className)}>
      <KibProductRating rating={5} className={styles.rating} />
      <div className={styles.title}>{title}</div>
      <p>{text}</p>

      <div className={styles.byline}>
        <KibAwardIcon
          className={styles.awardIcon}
          role="img"
          aria-label="Award Icon"
          focusable="false"
        />
        by {author}
      </div>
    </div>
  );
};
